<template >
  <div v-loading="!recipe">
    <el-row align="middle" type="flex" justify="center" :gutter="10">
      <el-col :sm="{span: 12}" :lg="{span: 10}">
        <div v-if="recipe && recipe.Title">
          <h1>{{recipe.Title}}</h1>
          <p>Souce: {{recipe.Author.Name}}</p>
          <a>Up Votes: {{recipe.Rating}}</a>
          <br>
          <br>
          <el-button class="button-m" type="info" plain @click="onShare" icon="el-icon-share">Share</el-button>
          <el-button
            class="button-m"
            :plain="!userHasUpVoted"
            :type="userHasUpVoted? 'primary': ''"
            icon="el-icon-arrow-up"
            @click="onVoteOrRemove"
          >Up Vote</el-button>
          <el-button
            class="button-m"
            @click="onFavoriteOrRemove"
            :plain="!userHasFavorited"
            :type="userHasFavorited? 'primary': ''"
          >
            <font-awesome-icon icon="heart" class="icon"/>Favorite
          </el-button>
          <br>
          <br>
          <el-collapse v-model="activeCollapse">
            <el-collapse-item title="Ingredients" name="1">
              <p v-for="i in recipe.Ingredients" :key="i.Id">{{i.Quantity}} {{i.Unit}} {{i.Name}}</p>
            </el-collapse-item>
            <el-collapse-item title="Instructions" name="2">
              <div class="justify-text">
                <p>{{recipe.Instructions}}</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="Uses" name="3">
              <span
                class="pad-button"
                v-for="use in recipe.RecipeUseCategories"
                v-bind:key="use.Id"
              >
                <use-button
                  @select="handleSelectUse"
                  v-if="use"
                  :useCategory="getCategory(use.UseCategoryId)"
                />
              </span>
            </el-collapse-item>
            <el-collapse-item title="Testimonials" name="4">
              <!-- filter out denied testimonials that are being sent -->
              <div
                v-for="testimonial in recipe.Testimonials.filter(t =>t.ApprovalStatus !== 2)"
                v-bind:key="testimonial.Id"
              >
                <testimonial @likeTestimonial="onLikeTestimonial" :testimonial="testimonial"/>
              </div>
              <el-button @click="isAddTestimonial= true" v-if="!isAddTestimonial">Add Testimonials</el-button>
              <create-testimonial
                v-else
                :user="user"
                :recipe="recipe"
                @cancel="isAddTestimonial = false"
              />
            </el-collapse-item>
          </el-collapse>
          <b-share
            header="How would you like to share?"
            :title="recipe.Title"
            :text="createTextForRecipe()"
            :dialogVisible="shareDialog"
            @closeDialog="shareDialog = false"
          />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import UseButton from '@/components/uses/UseButton'
import Testimonial from '@/components/recipes/Testimonial'
import CreateTestimonial from '@/components/recipes/CreateTestimonial'
import { mapGetters } from 'vuex'
import { HTTP } from '@/http-common'

export default {
  name: 'recipe',
  props: {
    recipeParam: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      activeCollapse: ['1', '2', '3', '4'],
      shareDialog: false,
      isAddTestimonial: false,
      recipe: null
    }
  },
  computed: {
    ...mapGetters(['categories', 'user']),
    userHasUpVoted() {
      return this.recipe.Ratings.some(
        r => r.UserId === this.user.Id && r.Rating === 1
      )
    },
    userHasFavorited() {
      return this.user.FavoriteRecipeIds.some(i => i === this.recipe.Id)
    }
  },
  watch: {
    recipeParam: {
      handler: 'handleRecipeParam',
      immediate: true
    }
  },
  methods: {
    handleRecipeParam(recipe) {
      if (recipe) {
        this.recipe = Object.assign({}, this.recipeParam)
      } else {
        HTTP.get('recipes/' + this.$route.query.id).then(response => {
          this.recipe = response.data
        })
      }
    },
    getCategory(UseCategoryId) {
      return this.categories.find(c => c.Id === UseCategoryId)
    },
    handleSelectUse(item) {
      this.$router.push({ path: '/uses/' + item.Id })
      this.$emit('closeDialog')
    },
    createTextForRecipe() {
      const title = this.recipe.Title + ' %0D%0A %0D%0A'
      const ingredients =
        this.recipe.Ingredients.map(
          i => `${i.Quantity || ''} ${i.Unit || ''} ${i.Name || ''}`
        ).join('%0D%0A') + '%0D%0A %0D%0A'
      const instructions = this.recipe.Instructions + '%0D%0A %0D%0A'
      const droplii = 'Shared with Droplii.com'
      return title + ingredients + instructions + droplii
    },
    onShare() {
      if (navigator.share) {
        navigator.share({
          title: this.recipe.Title,
          text: this.recipe.Instructions,
          url: 'https://developer.mozilla.org'
        })
      } else {
        this.shareDialog = true
      }
    },
    onVoteOrRemove() {
      const isUpVote = this.userHasUpVoted ? 0 : 1
      const voteRequest = {
        RecipeId: this.recipe.Id,
        UserId: this.user.Id,
        Vote: isUpVote
      }
      HTTP.post('recipes/vote', voteRequest).then(response => {
        this.recipe = response.data
      })
    },
    onFavoriteOrRemove() {
      const isFavorite = this.userHasFavorited ? false : true
      const favorite = {
        IsFavorite: isFavorite,
        RecipeId: this.recipe.Id,
        UserId: this.user.Id
      }
      this.$store.dispatch('updateFavoriteRecipe', favorite)
    },
    onLikeTestimonial(testimonial) {
      // Increases / decreases the rating.
      HTTP.post(
        `recipes/testimonials/toggleVote?id=${
          this.user.Id
        }&recipeTestimonialId=${testimonial.Id}`
      ).then(response => {
        this.$store.dispatch('getUser')
        const isLiked = !!response.data
        if (isLiked) {
          this.recipe.Testimonials = this.recipe.Testimonials.map(
            t =>
              t.Id === testimonial.Id
                ? Object.assign({}, t, { Rating: t.Rating + 1 })
                : t
          )
        } else {
          this.recipe.Testimonials = this.recipe.Testimonials.map(
            t =>
              t.Id === testimonial.Id
                ? Object.assign({}, t, { Rating: t.Rating - 1 })
                : t
          )
        }
      })
    }
  },
  components: {
    UseButton,
    Testimonial,
    CreateTestimonial
  }
}
</script>

<style scoped>
.aa-button {
  padding: 20px;
  margin: 20px;
}
.icon {
  margin-right: 5px;
}
.justify-text {
  text-align: justify;
}
.button-m {
  margin-top: 10px;
}
</style>
